module.exports = __webpack_public_path__ + "static/media/checkbox-check.15a8c578.svg";